import { render, staticRenderFns } from "./actualpath.vue?vue&type=template&id=2b6a1b5a&"
import script from "./actualpath.vue?vue&type=script&lang=js&"
export * from "./actualpath.vue?vue&type=script&lang=js&"
import style0 from "./actualpath.vue?vue&type=style&index=0&id=2b6a1b5a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports